export default {
  mail_status: {
    see_message: "Voir le message",
    see_incident: "Voir l'incident",
    not_filled: "Non renseigné",
    field_label: "Statut de la boîte mail",
    status: {
      valid: "Valide",
      valid_with_incident: "Incident signalé",
      temporary_block: "Blocage temporaire",
      definitive_block: "Blocage définitif",
    },
    category: {
      reputation: "Réputation de l'expéditeur",
      unknown_recipient: "Destinataire inconnu",
      other: "Autre",
    },
    reputation: {
      platform_alert:
        "Un problème de réputation qui nuit à la délivrabilité des e-mails a été détecté sur votre plate-forme. L'équipe technique a été alertée et travaille activement à le résoudre.",
    },
    code: {
      invalid_email_format: "Format d'adresse invalide",
      transport_error: "Erreur de transport",
      send_error: "Erreur d'envoi",
    },
    send_dot: {
      pending: "L'e-mail est en cours de préparation, il n'a pas encore été envoyé.",
      sent: "L'e-mail a bien été envoyé",
      incident: "L'e-mail a été envoyé mais le serveur destinataire l'a bloqué",
      blocked: "L'e-mail n'a pas été envoyé à cause d'un problème lié à l'adresse du destinataire",
      error: "L'e-mail n'a pas pu être envoyé à cause d'une erreur technique lors de l'envoi",
      unknown: "Le statut d'envoi de cet e-mail n'est pas reconnu",
    },
    modal: {
      title: "Email bloqué",
      title_incident: "Incident signalé sur l'adresse",
      title_valid: "Statut de la boîte mail",
      blocked_at: "Bloqué le",
      cause: "Cause",
      no_cause: "Aucun message renvoyé par le serveur",
      unblock: "Débloquer maintenant",
      unblock_error: "Le blocage n'a pas pu être levé, veuillez réessayer.",
      unblock_success: "Blocage levé — l'adresse est de nouveau considérée comme valide.",
      hint_blocked: "Corrigez l'adresse si besoin, puis débloquez manuellement.",
      hint_incident: "Un incident a été détecté mais n'a pas atteint le seuil de blocage — aucune action requise.",
      hint_valid: "Cette adresse fonctionne normalement, aucune action requise.",
    },
  },
};
